import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditCompany() {
  const [Company_data, setCompany_data] = useState([]);
  let { id } = useParams();
  const EmpId = localStorage.getItem("EmpId");
  const classes = useStyles();

  //fetch Data

  const data_params = { id: id };
  const getData = async () => {
    try {
      const data = await api
        .post("api/company/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              //   console.log(res);
              setCompany_data(res);
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Company");
                }
              });
            });
            // console.log("Nodata" + response);
          }
          //   console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // console.log(id);
    // GET request using axios inside useEffect React hook
    getData();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  const history = useHistory();
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          บริษัท
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Company
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Detail Company
            </Typography>
          </Grid>
        </Grid>

        <Formik
          enableReinitialize
          initialValues={{
            company_code: Company_data.CompanyCode,
            company_no: Company_data.CompanyNo,
            company_name: Company_data.CompanyName,
            company_status: Company_data.Status
              ? Company_data.Status === true ? 1 : 0
              : 0,
            address: Company_data.CompanyAddress,
            telephone: Company_data.CompanyMobile,
            fax: Company_data.CompanyFax,
            remark: Company_data.Remark,
          }}
          validate={(values) => {
            const errors = {};
            if (!values.company_code || values.company_code === "") {
              errors.company_code = "Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                id: Company_data.CompanyId,
                code: values.company_code,
                no: values.company_no,
                name: values.company_name,
                address: values.address,
                phone: values.telephone,
                fax: values.fax,
                remark: values.remark,
                status: values.company_status,
                ModId: EmpId,
              };

              api
                .post("api/company/update", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "แก้ไขบริษัทสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Company");
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <Grid container>
                <Grid item xs={12} md={12}>
                  <div style={{ display: "flex" }}>
                    <TextField
                      name="company_code"
                      label="Customer Code"
                      variant="outlined"
                      placeholder="Company"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.company_code}
                      classes={{ root: !values.company_code ? classes.customOutline :null }}
                      required
                    />
                    {/* {errors.company_code &&
                      touched.company_code &&
                      errors.company_code} */}
                    <TextField
                      name="company_no"
                      label="Company No"
                      variant="outlined"
                      placeholder="Company No"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "25%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.company_no}
                      required
                      classes={{ root: !values.company_no ? classes.customOutline :null }}
                    />
                    {/* {errors.company_no &&
                      touched.company_no &&
                      errors.company_no} */}
                    <FormControl style={{ width: "25%", marginRight: 5 }}>
                      <InputLabel id="select_status-label">Status</InputLabel>
                      <Select
                        name="company_status"
                        id="company_status"
                        value={values.company_status}
                        label="Status"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value={1}>Active</MenuItem>
                        <MenuItem value={0}>InActive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div style={{ display: "flex", marginTop: 10 }}>
                    <TextField
                      name="company_name"
                      label="Company Name"
                      variant="outlined"
                      placeholder="Company Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "50%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.company_name}
                      classes={{ root: !values.company_name ? classes.customOutline : null }}
                      required

                    />
                    {/* {errors.company_name &&
                      touched.company_name &&
                      errors.company_name} */}
                    <TextField
                      name="telephone"
                      label="Telephone"
                      variant="outlined"
                      placeholder="Telephone"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "25%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.telephone}
                    />
                    {errors.telephone && touched.telephone && errors.telephone}
                    <TextField
                      name="fax"
                      label="Fax"
                      variant="outlined"
                      placeholder="Fax"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "25%", marginRight: 5 }}
                      InputLabelProps={{ shrink: true }}
                      value={values.fax}
                    />
                    {errors.fax && touched.fax && errors.fax}
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <TextField
                      name="address"
                      label="Address"
                      variant="outlined"
                      placeholder="Address"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputLabelProps={{ shrink: true }}
                      value={values.address}
                      fullWidth
                    />
                    {errors.address && touched.address && errors.address}
                  </div>

                  <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <TextField
                      fullWidth
                      rows={3}
                      multiline={true}
                      label="Remark *"
                      placeholder="Remark"
                      InputLabelProps={{ shrink: true }}
                      name="remark"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.remark}
                    />
                    {errors.remark && touched.remark && errors.remark}
                  </div>
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
